// FF Header + Mega — overlay under body, menu above, no flicker + hover intent + close debounce
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.ff-header');
  if (!header) return;

  const openMode = header.getAttribute('data-open-mode') || 'hover';

  // ===== One canonical overlay under <body> =====
  const overlays = Array.from(document.querySelectorAll('.ff-page-dim'));
  let dim = overlays[0] || document.createElement('div');
  dim.classList.add('ff-page-dim');
  overlays.slice(1).forEach(o => o.remove());
  if (dim.parentElement !== document.body) document.body.prepend(dim);

  // --- Copy theme editor vars from .ff-header -> :root so body-level overlay can see them
  const seedVarsFromHeader = () => {
    const cs = getComputedStyle(header);
    const rawOp   = cs.getPropertyValue('--ff-dim-opacity').trim();
    const rawBlur = cs.getPropertyValue('--ff-blur').trim();
    if (rawOp)   document.documentElement.style.setProperty('--ff-dim-opacity', rawOp);
    if (rawBlur) document.documentElement.style.setProperty('--ff-blur', rawBlur);
  };

  const readOpacity = () => {
    let op = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ff-dim-opacity'));
    if (Number.isNaN(op)) op = parseFloat(getComputedStyle(header).getPropertyValue('--ff-dim-opacity'));
    if (Number.isNaN(op)) op = 0.14;
    return op <= 0 ? 0.001 : op;
  };
  const readBlurPx = () => {
    let b = getComputedStyle(document.documentElement).getPropertyValue('--ff-blur').trim();
    if (!b) b = getComputedStyle(header).getPropertyValue('--ff-blur').trim();
    const n = parseFloat(b);
    return Number.isNaN(n) ? 0 : n;
  };

  const syncOverlayStyle = () => {
    seedVarsFromHeader();
    const op = readOpacity();
    dim.style.zIndex = '2147482990';
    dim.style.background = `rgba(0,0,0, ${op})`;
    document.documentElement.style.setProperty('--ff-blur', `${readBlurPx()}px`);
  };
  syncOverlayStyle();
  window.addEventListener('resize', syncOverlayStyle);

  const showOverlay = (opts = {}) => {
  syncOverlayStyle();
  // On mobile (or if called as a “catcher”), do NOT dim/blur the page
  const asCatcher = opts.asCatcher || !isDesktop();
  if (asCatcher) {
    dim.classList.add('as-catcher');
    document.documentElement.classList.remove('ff-dim-on');
  } else {
    dim.classList.remove('as-catcher');
    document.documentElement.classList.add('ff-dim-on');
  }
  dim.classList.add('is-active');
};
const hideOverlay = () => {
  dim.classList.remove('is-active', 'as-catcher');
  document.documentElement.classList.remove('ff-dim-on');
};


  // ===== Underline driver (works with Button Animation Manager) =====
  function setUnderlineActive(item, on){
    if (!item) return;
    const lbl = item.querySelector('.ff-nav-link .ff-nav-label');
    if (!lbl) return;
    const hasFx = lbl.classList.contains('fx') || Array.from(lbl.classList).some(c => c.indexOf('fx--') === 0);
    if (!hasFx) return;
    lbl.style.backgroundSize = on ? '100% 2px' : '';
  }

  // ===== Fixed-header offset + drawer top =====
const drawer = header.querySelector('.ff-drawer');
const burger = header.querySelector('[data-burger]');

const setHeaderOffsets = () => {
  const cs = getComputedStyle(header);
  const h = Math.round(header.getBoundingClientRect().height || 72);
  const stroke = parseFloat(cs.getPropertyValue('--ff-header-stroke-w')) || 0;

  // Spacer = full header height (for page layout)
  document.documentElement.style.setProperty('--ff-header-fixed-h', `${h}px`);

  // Drawer should overlap the stroke so there's no visual "gap"
  // In scrollable mode (announcement bar sticky=OFF), add bar height
  if (drawer) {
    const isScrollable = document.documentElement.classList.contains('ff-announce-scrollable');
    const barH = isScrollable 
      ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ff-announce-bar-h')) || 0
      : 0;
    drawer.style.top = `${Math.max(0, barH + h - stroke)}px`;
  }
};
requestAnimationFrame(setHeaderOffsets);
window.addEventListener('load', setHeaderOffsets, { once:true });
window.addEventListener('resize', setHeaderOffsets);
window.addEventListener('orientationchange', setHeaderOffsets);
new ResizeObserver(setHeaderOffsets).observe(header);


  // ===== Auto-height (desktop mega fit) =====
  function ffClampCollagesToText(mega){
    if (!mega || mega.classList.contains('ff-mega--fixed')) return;
    const group = mega.querySelector('.ff-mega__group');
    if (!group) return;
    const textCols = Array.from(group.querySelectorAll('.ff-mega__col'))
      .filter(c => !c.classList.contains('ff-collage-col'));
    let target = 0;
    textCols.forEach(c => { target = Math.max(target, Math.ceil(c.getBoundingClientRect().height)); });
    if (target <= 0) return;
    group.style.setProperty('--ff-auto-h', `${target}px`);
  }
  function ffClampActive(){
    const mega = header.querySelector('.ff-nav-item[aria-expanded="true"] .ff-mega');
    if (mega) ffClampCollagesToText(mega);
  }
  let _ffClampTimer = null;
  window.addEventListener('resize', () => {
    if (_ffClampTimer) cancelAnimationFrame(_ffClampTimer);
    _ffClampTimer = requestAnimationFrame(ffClampActive);
  });

  // ===== Desktop mega (hover intent + close debounce) =====
  const OPEN_DELAY  = 0;
  const DRIFT_DELAY = 150;
  const CLOSE_DELAY = 140;
  const CORRIDOR_PAD = 8;

  let openTimer = null;
  let driftTimer = null;
  let closeTimer = null;

  const clearCloseTimer = () => { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } };
  const scheduleOpen = (item) => {
    if (openTimer) clearTimeout(openTimer);
    openTimer = setTimeout(() => openItem(item), OPEN_DELAY);
  };
  const cancelOpen = () => { if (openTimer) { clearTimeout(openTimer); openTimer = null; } };

  const closeAllMega = () => {
    header.querySelectorAll('.ff-nav-item[aria-expanded="true"]').forEach(el => {
      el.setAttribute('aria-expanded','false');
      setUnderlineActive(el, false);
    });
    hideOverlay();
  };

  const openItem = (item) => {
    clearCloseTimer();
    header.querySelectorAll('.ff-nav-item').forEach(el => {
      const on = el === item;
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
      setUnderlineActive(el, on);
    });
    showOverlay();
    ffClampCollagesToText(item.querySelector('.ff-mega'));
  };

  header.addEventListener('mouseleave', (e) => {
    const toEl = e.relatedTarget;
    const enteringMega = toEl && (toEl.closest?.('.ff-mega') || toEl.classList?.contains('ff-mega'));
    if (!enteringMega) closeAllMega();
  });

  const startDriftCloseCheck = (e) => {
    const active = header.querySelector('.ff-nav-item[aria-expanded="true"]');
    if (!active) return;

    if (e.target.closest('.ff-nav-item') || e.target.closest('.ff-mega')) {
      if (driftTimer) { clearTimeout(driftTimer); driftTimer = null; }
      return;
    }

    const links = header.querySelectorAll('.ff-header__nav .ff-nav-link');
    let min = Infinity, max = -Infinity;
    links.forEach(l => {
      const r = l.getBoundingClientRect();
      if (r.width === 0) return;
      if (r.left  < min) min = r.left;
      if (r.right > max) max = r.right;
    });
    if (!Number.isFinite(min) || !Number.isFinite(max)) return;

    const x = e.clientX;
    const insideCorridor = x >= (min - CORRIDOR_PAD) && x <= (max + CORRIDOR_PAD);

    if (insideCorridor) {
      if (driftTimer) { clearTimeout(driftTimer); driftTimer = null; }
    } else {
      if (!driftTimer) {
        driftTimer = setTimeout(() => {
          driftTimer = null;
          closeAllMega();
        }, DRIFT_DELAY);
      }
    }
  };
  header.addEventListener('mousemove', startDriftCloseCheck);

  try {
    const _ffDimObserver = new MutationObserver(() => {
      const anyMegaOpen = header.querySelector('.ff-nav-item[aria-expanded="true"]');
      const drawerEl = header.querySelector('.ff-drawer') || document.getElementById('ff-drawer');
      const drawerOpen = drawerEl && drawerEl.getAttribute('aria-hidden') === 'false';
      if (anyMegaOpen || drawerOpen) { showOverlay(); } else { hideOverlay(); }

      header.querySelectorAll('.ff-nav-item').forEach(it => {
        setUnderlineActive(it, it.getAttribute('aria-expanded') === 'true');
      });
    });
    _ffDimObserver.observe(header, { attributes: true, subtree: true, attributeFilter: ['aria-expanded','aria-hidden'] });
  } catch(e){ console.error('[FF] dim observer error', e); }

  header.querySelectorAll('.ff-nav-item').forEach(item => {
    const link = item.querySelector('.ff-nav-link');
    const mega = item.querySelector('.ff-mega');
    if (!link || !mega) return;

    item.addEventListener('mouseenter', () => {
      clearCloseTimer();
      if (openMode === 'hover') scheduleOpen(item);
    });

    if (openMode === 'hover') {
      link.addEventListener('mouseenter', () => { clearCloseTimer(); scheduleOpen(item); });
      link.addEventListener('focus', () => { cancelOpen(); openItem(item); });
    } else {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        cancelOpen(); clearCloseTimer();
        const expanded = item.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          item.setAttribute('aria-expanded','false');
          setUnderlineActive(item, false);
          const anyOpen = header.querySelector('.ff-nav-item[aria-expanded="true"]');
          if (!anyOpen) hideOverlay();
        } else {
          openItem(item);
        }
      });
    }

    mega.addEventListener('mouseenter', () => {
      cancelOpen(); clearCloseTimer();
      item.setAttribute('aria-expanded','true');
      setUnderlineActive(item, true);
      showOverlay();
    });

    mega.addEventListener('mouseleave', (e) => {
      const toEl = e.relatedTarget;
      const goingToHeader = !!(toEl && header.contains(toEl));
      if (goingToHeader) {
        clearCloseTimer();
        closeTimer = setTimeout(() => {
          if (item.getAttribute('aria-expanded') === 'true') {
            item.setAttribute('aria-expanded','false');
            setUnderlineActive(item, false);
            const anyOpen = header.querySelector('.ff-nav-item[aria-expanded="true"]');
            if (!anyOpen) hideOverlay();
          }
        }, CLOSE_DELAY);
      } else {
        item.setAttribute('aria-expanded','false');
        setUnderlineActive(item, false);
        const anyOpen = header.querySelector('.ff-nav-item[aria-expanded="true"]');
        if (!anyOpen) hideOverlay();
      }
    });
  });

  // Click overlay = close everything
  dim.addEventListener('click', () => { closeAllMega(); closeDrawer(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeAllMega(); closeDrawer(); }
  });

  // ===== Scroll-lock with scrollbar compensation =====
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

function setScrollLock(on){
  const root = document.documentElement;
  const body = document.body;
  if (on) {
    const scrollBarW = window.innerWidth - root.clientWidth;
    root.classList.add('ff-no-scroll');
    // Only pad on desktop for scrollbar compensation
    body.style.paddingRight = (scrollBarW > 0 && isDesktop()) ? `${scrollBarW}px` : '';
    // Explicitly prevent iOS/Android from allowing any scroll while drawer is open
    body.style.overflow = 'hidden';
  } else {
    root.classList.remove('ff-no-scroll');
    body.style.paddingRight = '';
    body.style.overflow = '';
  }
}



  // ===== Mobile drawer + slider submenus =====
  const mnav = drawer?.querySelector('[data-mnav]');
  const viewport = mnav?.querySelector('.ff-mnav__viewport');
  const shadowTarget = drawer; // Shadow classes go on drawer (mnav has contain:paint which clips shadows)
  const track = mnav?.querySelector('[data-track]');
  const mq = window.matchMedia('(min-width: 990px)');
// Robust CSS.escape fallback for older browsers
const cssEscape = (s) =>
  (window.CSS && typeof CSS.escape === 'function')
    ? CSS.escape(s)
    : String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');


// ---- Virtualize sub-panes: keep ONLY root + active sub in the track
const rootPane = track?.querySelector('.ff-mpane--root');
const stash = document.createElement('div'); // hidden parking for all sub panes
stash.style.display = 'none';
if (track) track.after(stash);

// Root pane scroll shadows - absolute positioning with conditional visibility
let shadowTop, shadowBottom;
const shadowTopOn = '0 4px 18px rgba(0,0,0,0.2)';
const shadowBottomOn = '0 -4px 18px rgba(0,0,0,0.2)';

if (mnav) {
  shadowTop = document.createElement('div');
  shadowTop.className = 'ff-mnav__shadow-top';
  shadowTop.style.cssText = `
    position: absolute;
    top: -12px;
    left: 0;
    right: 0;
    height: 12px;
    background: transparent;
    z-index: 99999;
    pointer-events: none;
    box-shadow: none;
    transition: box-shadow 0.18s ease;
  `;
  shadowTop.innerHTML = '&nbsp;';
  
  shadowBottom = document.createElement('div');
  shadowBottom.className = 'ff-mnav__shadow-bottom';
  shadowBottom.style.cssText = `
    position: absolute;
    bottom: -12px;
    left: 0;
    right: 0;
    height: 12px;
    background: transparent;
    z-index: 99999;
    pointer-events: none;
    box-shadow: none;
    transition: box-shadow 0.18s ease;
  `;
  shadowBottom.innerHTML = '&nbsp;';
  
  mnav.insertBefore(shadowTop, mnav.firstChild);
  mnav.appendChild(shadowBottom);
  
}

// Move every sub-pane out of the track initially
if (track) Array.from(track.querySelectorAll('.ff-mpane--sub')).forEach(p => stash.appendChild(p));

// We only ever have 0:root and (optionally) 1:activeSub inside the track
let currentIndex = 0;
function setTrackToIndex(newIndex){
  if (!track) return;
  track.style.transitionDuration = (newIndex !== currentIndex) ? '260ms' : '0ms';
  track.style.transform = (newIndex === 0) ? 'translateX(0)' : 'translateX(-100%)';
  currentIndex = newIndex;
}
function syncTrack(){ setTrackToIndex(currentIndex); } // percent-based, no offset math


 function goRoot(){
  if (!drawer || !track || !rootPane) return;
  drawer.dataset.level = 'root';
  // Leave only root in the track
  Array.from(track.children).forEach(ch => { if (ch !== rootPane) stash.appendChild(ch); });
  setTrackToIndex(0);
  observePane(rootPane, shadowTarget);
  clampPaneScroll(rootPane, shadowTarget);
}

function goSub(id){
  if (!drawer || !track || !rootPane) return;

  // Find the matching sub-pane (prefer the stashed one)
  const pane =
    stash.querySelector(`#pane-${cssEscape(id)}`) ||
    document.getElementById(`pane-${id}`);

  if (!pane) return;

  drawer.dataset.level = 'sub';

  // Replace any existing sub with the requested one
  Array.from(track.children).forEach(ch => { if (ch !== rootPane) stash.appendChild(ch); });
  track.appendChild(pane);

  // Clear root-scrolled since root pane is no longer visible
  if (shadowTarget) shadowTarget.classList.remove('root-scrolled');

  observePane(pane, shadowTarget);

  // Mark active purely for styling/debug (optional)
  stash.querySelectorAll('.ff-mpane--sub.is-active').forEach(p => p.classList.remove('is-active'));
  pane.classList.add('is-active');

  setTrackToIndex(1);
  clampPaneScroll(pane, shadowTarget);
}


function clampPaneScroll(pane, shadowTarget){
  if (!pane) return;
  const fits = pane.scrollHeight <= pane.clientHeight + 1;
  const hasOverflowBelow = (pane.scrollHeight - pane.scrollTop - pane.clientHeight) > 2;
  
  pane.classList.toggle('no-scroll', fits);
  pane.classList.toggle('has-overflow-below', hasOverflowBelow);
  
  // Also update shadowTarget for legacy compatibility
  if (shadowTarget) {
    shadowTarget.classList.toggle('has-overflow-below', hasOverflowBelow);
  }
  
  // Update bottom shadow (visible on both root and sub-menus)
  if (shadowBottom) {
    shadowBottom.style.boxShadow = hasOverflowBelow ? shadowBottomOn : 'none';
  }
}



function observePane(pane, shadowTarget){
  if (!pane) return;

  function setPaneScrolledState(){
    const scrolled = (pane.scrollTop || 0) > 2;
    const hasOverflowBelow = (pane.scrollHeight - pane.scrollTop - pane.clientHeight) > 2;
    const isRootPane = pane.classList.contains('ff-mpane--root');
    
    pane.classList.toggle('is-scrolled', scrolled);
    pane.classList.toggle('has-overflow-below', hasOverflowBelow);
    
    // Also update shadowTarget for legacy compatibility
    if (shadowTarget && isRootPane) {
      shadowTarget.classList.toggle('root-scrolled', scrolled);
    }
    if (shadowTarget) {
      shadowTarget.classList.toggle('has-overflow-below', hasOverflowBelow);
    }
    
    // Toggle root pane shadows
    // Top shadow: only on root pane (sub-menus have their own header shadow)
    // Bottom shadow: on both root and sub-menus
    if (shadowTop) {
      shadowTop.style.boxShadow = (isRootPane && scrolled) ? shadowTopOn : 'none';
    }
    if (shadowBottom) {
      shadowBottom.style.boxShadow = hasOverflowBelow ? shadowBottomOn : 'none';
    }
  }

  pane.addEventListener('scroll', setPaneScrolledState);
  // initialize once pane is mounted
  setTimeout(setPaneScrolledState, 0);

  // Re-check after images load
  pane.querySelectorAll('img').forEach(img => {
    if (!img.complete) {
      img.addEventListener('load', () => clampPaneScroll(pane, shadowTarget), { once: true });
    }
  });

  // Re-check whenever a <details> (ff-drop) opens/closes
  pane.querySelectorAll('details').forEach(d => {
    d.addEventListener('toggle', () => clampPaneScroll(pane, shadowTarget));
  });
}


  function openDrawer() {
  if (!drawer) return;
  setHeaderOffsets(); // ensure top accounts for stroke immediately
  
  // Check if at top of page - skip transition if so
  const isAtTop = window.scrollY <= 10;
  if (isAtTop) {
    header.classList.add('is-at-top');
  }
  
  drawer.setAttribute('aria-hidden','false');
  header.classList.add('is-drawer-open');
  burger?.setAttribute('aria-expanded','true');
  showOverlay({ asCatcher: true });
  setScrollLock(true);
  goRoot();
  observePane(rootPane, shadowTarget);
  clampPaneScroll(rootPane, shadowTarget);
  
  // Remove is-at-top after a frame so future transitions work
  if (isAtTop) {
    requestAnimationFrame(() => {
      header.classList.remove('is-at-top');
    });
  }
}

  function closeDrawer() {
    if (!drawer) return;
    
    // Check if we're scrolled - only animate if not at top
    const isScrolled = window.scrollY > 10;
    
    if (isScrolled) {
      // Add closing class so header animates up and covers announcement bar
      header.classList.add('is-drawer-closing');
    }
    
    header.classList.remove('is-drawer-open');
    drawer.setAttribute('aria-hidden','true');
    burger?.setAttribute('aria-expanded','false');
    hideOverlay();
    setScrollLock(false);
    goRoot();
    
    // Remove closing class after transition completes
    if (isScrolled) {
      setTimeout(() => header.classList.remove('is-drawer-closing'), 220);
    }
  }

  burger?.addEventListener('click', (e) => {
    e.preventDefault();
    const hidden = drawer?.getAttribute('aria-hidden') !== 'false';
    hidden ? openDrawer() : closeDrawer();
  });
  mq.addEventListener('change', () => { if (mq.matches) closeDrawer(); });

window.addEventListener('resize', () => {
  if (drawer?.getAttribute('aria-hidden') === 'false') {
    syncTrack();
    const active = track?.querySelector('.ff-mpane.is-active') || rootPane;
    clampPaneScroll(active, shadowTarget);
  }
});
window.addEventListener('orientationchange', () => {
  if (drawer?.getAttribute('aria-hidden') === 'false') {
    syncTrack();
    const active = track?.querySelector('.ff-mpane.is-active') || rootPane;
    clampPaneScroll(active, shadowTarget);
  }
});


  // Delegate clicks for open-sub/back
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-open-sub]');
      const backBtn = e.target.closest('[data-back]');
// inside drawer click delegate, REPLACE the whole RIGHT_ZONE block with this:
const sum = e.target.closest('.ff-drop__summary');
if (sum && sum.closest('.ff-mpane')) {
  const href = sum.dataset.link;
  if (href) {
    const titleEl = sum.querySelector('.ff-drop__title');
    const r = (titleEl || sum).getBoundingClientRect();
    const x = e.clientX, y = e.clientY;
    const withinTitle = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;

    if (withinTitle) {
      // click landed on the title text → go to the column URL
      e.preventDefault();
      e.stopPropagation();
      window.location.assign(href);
      return;
    }
    // click landed OUTSIDE the title text → let <summary> toggle the dropdown
  }
}




      if (openBtn) {
        e.preventDefault();
        goSub(openBtn.getAttribute('data-open-sub'));
        clampPaneScroll(track.querySelector('.ff-mpane.is-active') || rootPane, shadowTarget);
        return;
      }
      if (backBtn) {
        e.preventDefault();
        goRoot();
        clampPaneScroll(rootPane, shadowTarget);
        return;
      }
      // Let the optional right-side header link work like a normal link
if (e.target.closest('.ff-head-link')) {
  return;
}

    });
  }

  // Expose helpers (debug)
  window.ffShowDim = showOverlay;
  window.ffHideDim = hideOverlay;
  window.ffOpenDrawer = openDrawer;
  window.ffCloseDrawer = closeDrawer;
});